import { useEffect } from "react";
import { GRID_SEARCH_DEBOUNCE_MS } from "../Constants/gridDebounce";

/**
 * Runs callback after delay when deps change (Pattern A grid fetch debounce).
 */
export default function useDebouncedEffect(callback, deps, delay = GRID_SEARCH_DEBOUNCE_MS) {
  useEffect(() => {
    const handler = setTimeout(() => {
      callback();
    }, delay);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay]);
}
